import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EventComponent} from '../../../shared/api/model/event-component';

@Component({
  selector: 'app-book-extras',
  templateUrl: './book-extras.component.html',
  styleUrls: ['./book-extras.component.scss']
})
export class BookExtrasComponent implements OnInit {
  @Input('components') components: EventComponent[];
  @Output() onChange = new EventEmitter<EventComponent[]>();
  @Input('hasAccess') hasAccess: boolean;
  @Input('extras') extras = [];
  @Input('extrasFromEventComponents') extrasFromEventComponents = [];

  constructor() {
    // console.log('this.components in constructor :>> ', this.components);
   }

  ngOnInit() {
    if (this.components === undefined) {
      this.components = this.extrasFromEventComponents;
      this.components.map( (component) => {
        component.quantity = 0; // start with 0
      })
      // this.components = [];
      // for (const extra of this.extras) {
      //   const component = new EventComponent();
      //   component.component = extra.item;
      //   component.componentPrice = extra.selectedPrice;
      //   component.quantity = 0;
      //   this.components.push(component);
      // }
    }
  }

  updateComponentQuantity(componentId: number, priceId: number, quantity: number) {
    for (const component of this.components) {
      if (component.component.id === componentId && component.componentPrice.id === priceId) {
        component.quantity = quantity;
        break;
      }
    }

    this.onChange.emit(this.components);
  }

  isComponentUnlimited(componentId: number): boolean {
    let result = false;
    for (let i = 0; this.extras.length > i; i++) {
      if (this.extras[i]['id'] === componentId) {
        result = this.extras[i]['capacityUnlimited'];
        break;
      }
    }
    return result;
  }

  get totalPrice(): number {
    let result = 0;
    for (const component of this.components) {
      if (component.component.componentType === 0) {
        result += (component.quantity * component.componentPrice.grossprice);
      }
    }
    return result;
  }

  get totalQuantity(): number {
    let result = 0;
    for (const component of this.components) {
      if (component.component.componentType === 0) {
        result += component.quantity;  
      }
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/experiences/booking/book-extras/book-extras.component.ts